import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getStartedPropertyResource } from '@jira/router-resources__service-desk-customer-service-get-started-property/src/getStartedPropertyResource.tsx';

import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmWidgetLayout } from '@jira/customer-service__csm-support-widget-layout/src/csmWidgetLayout.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsGetStartedRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsGetStartedRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import {
	composeLayouts,
	layoutWithCondition,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { serviceDeskIncomingEmailResource } from '@jira/router-resources__service-desk-incoming-email/src/serviceDeskIncomingEmailResource.tsx';

import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingGetStartedAppPageEntryPoint } from './ui/get-started/index.tsx';

export const helpCenterSettingsGetStartedRouteEntry: Route = createEntry(
	helpCenterSettingsGetStartedRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.get-started',
		layout: layoutWithCondition(
			() => fg('csm-support-widget-in-csm'),
			composeLayouts(serviceProjectLayout, csmWidgetLayout),
			serviceProjectLayout,
		),
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return helpCenterSettingGetStartedAppPageEntryPoint;
		},
		resources: [
			...jiraSpaResources(),
			...getServiceDeskSettingsResources(),
			getStartedPropertyResource,
			customerExperiencesNavigationResource,
			csmHubSetupSupportWebsiteResource,
			serviceDeskIncomingEmailResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
